// extracted by mini-css-extract-plugin
export default {"arrow_btns":"SmallBanner_arrow_btns__vKlwY"};